import { isComposerActive } from './composerMode';

/** Bot flows and template customer actions are paused while an intervene session is active. */
export function isInterveneAutomationPaused(composerMode) {
  return isComposerActive(composerMode);
}
